import { jsx as _jsx } from "react/jsx-runtime";
import { TriangleDown } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo } from "react";
export const GallerySectionHeader = /*#__PURE__*/ memo((param)=>{
    let { children, collapsed, onToggleCollapse, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        "aria-expanded": collapsed !== undefined ? !collapsed : undefined,
        className: "group/gallery-section-header",
        "data-collapsed": collapsed,
        ...restOfProps,
        children: /*#__PURE__*/ _jsx(Button, {
            appearance: "ghost",
            color: "grey",
            onClick: onToggleCollapse,
            size: "small",
            suffix: /*#__PURE__*/ _jsx(TriangleDown, {
                className: "size-3 transition-transform group-data-[collapsed=true]/gallery-section-header:-rotate-90"
            }),
            children: /*#__PURE__*/ _jsx("span", {
                className: "font-bold uppercase tracking-wider",
                children: children
            })
        })
    });
});
GallerySectionHeader.displayName = "GallerySectionHeader";
